module.exports = __webpack_public_path__ + "static/media/mechico-manuel-arroyo.ca74f9e6.jpg";